<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="title-wrapper">
      <h1 class="title-default">Reajuste de Preços</h1>
      <p class="welcome-message">
        <button mat-icon-button routerLink="../">
          <mat-icon>arrow_back</mat-icon>
        </button>
        Reajuste #{{ resumo ? resumo.idProdutoReajustePreco : '...' }} · somente leitura
      </p>
      @if (resumo?.idNFeEntrada) {
      <p class="welcome-message mb-0">
        Documento de origem:
        <a [routerLink]="['/suprimentos/nota-fiscal-entrada/documento', resumo?.idNFeEntrada]" [queryParams]="{ modo: 'visualizar' }">NF-e de entrada</a>
      </p>
      }
    </div>

    @if (isLoading) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (resumo) {
    <div class="section-container">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
        <span>Resumo do reajuste</span>
      </div>

      <div class="row g-3">
        <div class="col-12 col-md-4">
          <small class="d-block">Usuário</small>
          <span class="text-bold">{{ nomeUsuario }}</span>
        </div>
        <div class="col-12 col-md-4">
          <small class="d-block">Data / Hora</small>
          <span class="text-bold">{{ resumo.datetimeInclusao | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="col-12 col-md-4">
          <small class="d-block">Lista de preço afetada</small>
          <span class="text-bold">{{ resumo.listaPreco }}</span>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">list_alt_check</mat-icon>
        <span>Produtos reajustados ({{ itens.length }})</span>

        <div class="section-title-actions ms-auto">
          <button type="button" mat-icon-button title="Imprimir" (click)="imprimir()" class="mat-icon-btn-pd">
            <span class="material-symbols-outlined">print</span>
          </button>
          <button type="button" mat-icon-button title="Download" (click)="exportar()" class="mat-icon-btn-pd">
            <span class="material-symbols-outlined">file_download</span>
          </button>
        </div>
      </div>
      <div class="table-responsive desktop-view">
        <table mat-table [dataSource]="itens">
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td mat-cell *matCellDef="let item">{{ item.nome }}</td>
          </ng-container>

          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef>Código</th>
            <td mat-cell *matCellDef="let item">{{ item.codigoSku }}</td>
          </ng-container>

          <ng-container matColumnDef="unidade">
            <th mat-header-cell *matHeaderCellDef class="text-center">Unidade</th>
            <td mat-cell *matCellDef="let item" class="text-center">{{ item.unidadeMedida }}</td>
          </ng-container>

          <ng-container matColumnDef="precoAnterior">
            <th mat-header-cell *matHeaderCellDef class="text-end">Preço Anterior</th>
            <td mat-cell *matCellDef="let item" class="text-end">{{ item.precoAnterior | abnt:'preco' }}</td>
          </ng-container>

          <ng-container matColumnDef="precoAplicado">
            <th mat-header-cell *matHeaderCellDef class="text-end">Preço Aplicado</th>
            <td mat-cell *matCellDef="let item" class="text-end text-bold">{{ item.precoAplicado | abnt:'preco' }}</td>
          </ng-container>

          <ng-container matColumnDef="variacao">
            <th mat-header-cell *matHeaderCellDef class="text-end">Variação</th>
            <td mat-cell *matCellDef="let item" class="text-end">
              <span [ngClass]="variacao(item) >= 0 ? 'reajuste-positivo' : 'reajuste-negativo'">
                {{ variacao(item) | number: '1.2-2' }}%
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <div class="mobile-view">
        @for (item of itens; track item.idProduto) {
        <div class="card-mobile mb-3">
          <div class="card-header-mobile">
            <span class="text-bold">{{ item.nome }}</span>
            <small class="d-block">SKU: {{ item.codigoSku }}</small>
          </div>
          <div class="card-body-mobile p-3">
            <div class="row">
              <div class="col-6 mb-2">
                <small class="d-block">Preço Anterior</small>
                <span>{{ item.precoAnterior | abnt:'preco' }}</span>
              </div>
              <div class="col-6 mb-2">
                <small class="d-block">Preço Aplicado</small>
                <span class="text-bold">{{ item.precoAplicado | abnt:'preco' }}</span>
              </div>
              <div class="col-6 mb-2">
                <small class="d-block">Variação</small>
                <span [ngClass]="variacao(item) >= 0 ? 'reajuste-positivo' : 'reajuste-negativo'">
                  {{ variacao(item) | number: '1.2-2' }}%
                </span>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>